export default __webpack_public_path__ + "static/Complaints_Handling_Policy-8199b4116538182bbee206f13d6fcf5d.pdf";